function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "ic-avatar_svg__a",
  width: 28,
  height: 28,
  x: 0,
  y: 0,
  rx: 6
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ic-avatar_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ic-avatar_svg__a"
})), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 27,
  x: 0.5,
  y: 0.5,
  stroke: "#F6F6F6",
  rx: 6
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-avatar_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFB500",
  d: "M19.42 12.252c-.926 0-1.674-.75-1.674-1.675v-.002.002a4.202 4.202 0 01-4.197 4.195c1.79 0 3.435.631 4.731 1.678a7.543 7.543 0 002.816-5.869 1.674 1.674 0 01-1.675 1.67m-5.873-9.224c.128 0 .252.014.38.019A1.734 1.734 0 0013.547 3C9.386 3 6 6.386 6 10.548v12.218a1.676 1.676 0 103.352 0v-5.918A7.55 7.55 0 016 10.577v-.024a1.676 1.676 0 003.351 0v.024l.001.004v-.033c0-2.269 1.812-4.11 4.063-4.183a1.668 1.668 0 01-1.542-1.662c0-.925.75-1.676 1.675-1.676"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58220",
  d: "M18.28 16.45a7.503 7.503 0 00-4.731-1.677h-.001a4.201 4.201 0 01-4.196-4.192v-.028a1.677 1.677 0 01-3.352 0v.024a7.547 7.547 0 003.352 6.27 7.497 7.497 0 004.196 1.28 4.201 4.201 0 014.198 4.196v.442a1.674 1.674 0 103.35 0v-.442c0-2.371-1.1-4.489-2.816-5.873M13.415 6.365c.045.004.088.015.132.015a4.201 4.201 0 014.199 4.195v.001a1.675 1.675 0 003.35.006v-.006c0-4.035-3.183-7.33-7.17-7.53-.125-.006-.25-.018-.379-.018-.924 0-1.674.75-1.674 1.675 0 .88.679 1.595 1.542 1.662"
})));

function SvgIcAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28
  }, props), _ref, _ref2);
}

export default SvgIcAvatar;